<template>
  <div>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between pt-2">
        <h1 class="text-h4 mb-2">Gerenciar Boletos</h1>
      </v-col>
    </v-row>

    <!-- Filtros / topo -->
    <v-expansion-panels v-model="filtersExpanded" class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row no-gutters>
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-filter</v-icon>
              <span class="text-subtitle-1">Filtros</span>
            </div>
          </v-row>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row class="mb-4" align="center">
            <v-col cols="12" md="2">
              <v-select v-model="filters.status" :items="meta.filters.find(f => f.name === 'status').options"
                item-title="t" item-value="v" label="Status" dense />
            </v-col>

            <v-col cols="12" md="2">
              <v-select v-model="filters.nf" :items="meta.filters.find(f => f.name === 'nf').options" item-title="t"
                item-value="v" label="NF" dense />
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field v-model="filters.dtinicio" label="Dt Início" type="date" dense />
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field v-model="filters.dtfim" label="Dt Fim" type="date" dense />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field v-model="filters.textoBusca" label="Pesquisar (razão, responsável, email, cnpj)" dense
                clearable />
            </v-col>
          </v-row>

          <!-- botões de filtro -->
          <div>
            <v-btn color="primary" class="me-2" @click="search()">Aplicar Filtros</v-btn>
            <v-btn variant="outlined" @click="
              filters.status = 'x';
            filters.nf = '';
            filters.dtinicio = '';
            filters.dtfim = '';
            filters.textoBusca = '';
            ">Limpar Filtros</v-btn>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Ações / botões -->
    <v-row class="mb-3" align="center">
      <v-col cols="12" md="8">
        <v-btn variant="outlined" class="me-2" @click="doCopy">
          <v-icon left>mdi-content-copy</v-icon>
          Copiar</v-btn>
        <v-btn variant="outlined" class="me-2" @click="doCSV">
          <v-icon left>mdi-file-delimited</v-icon>
          CSV</v-btn>
        <v-btn variant="outlined" class="me-2" @click="doExcel">
          <v-icon left>mdi-file-excel</v-icon>
          Excel</v-btn>
        <v-btn variant="outlined" class="me-2" @click="doPDF">
          <v-icon left>mdi-file-pdf-box</v-icon>
          PDF</v-btn>
        <v-btn variant="outlined" class="me-2" @click="doPrint">
          <v-icon left>mdi-printer</v-icon>
          Imprimir</v-btn>
      </v-col>

      <v-col cols="12" md="4" class="text-end">
        <div><strong>Total valor boletos:</strong> {{ formatCurrency(totalValorBoleto) }}</div>
      </v-col>
    </v-row>

    <v-alert v-if="error" type="error" class="mb-4">{{ store.error }}</v-alert>

    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2"></v-progress-linear>

    <!-- Tabela -->
    <v-row id="manual-root" class="text-caption">
      <v-col cols="12">
        <v-data-table :items="items" :items-per-page="itemsPerPage" :headers="tableHeaders" class="elevation-1"
          disable-sort>
          <template #item.idrevendedor="{ item }">
            <div class="text-left">#{{ item.idrevendedor }}</div>
          </template>

          <!-- formatação das datas tabela -->
          <template #item.data="{ item }">
            <div class="text-center">{{ formatToDateBR(item.data) }}</div>
          </template>
          <template #item.vencimento="{ item }">
            <div class="text-center">{{ formatToDateBR(item.vencimento) }}</div>
          </template>

          <template #item.valorBoleto="{ item }">
            <div class="text-end">{{ formatCurrency(item.valorBoleto) }}</div>
          </template>

          <template #item.statusboleto="{ item }">
            <div class="text-center">
              {{ item.statusboleto }}
            </div>
          </template>

          <template #item.nf="{ item }">
            <v-select :items="meta.nfOptions" item-title="t" item-value="v" v-model="item.nf" dense hide-details
              @change="updateRow(item.id, 'nf', $event)" />
          </template>

          <template #item.acoes="{ item }">
            <v-select :items="meta.rowActions" item-title="t" item-value="v" v-model="rowActionSelections[item.id]"
              label="Ações" dense hide-details @update:model-value="val => onRowActionChange(item, val)" />
          </template>

          <template #bottom>
            <div class="d-flex justify-space-between align-center px-4 py-2">
              <div class="d-flex align-center">
                <span class="text-caption text-secondary mr-4">
                  Total de {{ totalItems }} item{{ (totalItems || 0) > 1 ? 's' : '' }}
                </span>

                <v-select v-model="itemsPerPage" :items="meta.limites" label="Itens por página" variant="outlined" dense
                  hide-details style="width: 140px" />
              </div>

              <v-pagination v-if="totalPages > 1" :model-value="pagina" :length="totalPages" :total-visible="5"
                @update:model-value="(newPage) => pagina = newPage" rounded class="my-2"></v-pagination>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Modal Alterar Valor -->
    <v-dialog v-model="dialogs.alterarValor" width="700">
      <v-card>
        <v-card-title>Alterar Valor / Vencimento</v-card-title>
        <v-card-text>
          <v-row>
            <!-- Seção Gás/Botijões -->
            <v-col cols="12">
              <h3 class="text-subtitle-1 mb-2">Gás (Botijões)</h3>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="alterarValorForm.npedidos" label="Nº Pedidos" type="number"
                hint="Número de pedidos de gás" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="alterarValorForm.qtdGas" label="Quantidade de Botijões" type="number"
                hint="Quantidade de botijões de gás" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field :model-value="alterarValorForm.valorGas" label="Valor Gás" readonly variant="solo-filled"
                class="readonly-highlight" hint="Valor do gás (Read-only)" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field :model-value="alterarValorForm.taxaServicoGas"
                @update:model-value="(v) => onCurrencyInput('taxaServicoGas', v)" label="Taxa Serviço Gás"
                hint="Taxa de serviço do gás" />
            </v-col>

            <!-- Seção Água -->
            <v-col cols="12" class="mt-3">
              <h3 class="text-subtitle-1 mb-2">Água</h3>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="alterarValorForm.npedidosAgua" label="Nº Pedidos Água" type="number"
                hint="Número de pedidos de água" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="alterarValorForm.qtdAgua" label="Quantidade de Água" type="number"
                hint="Quantidade de água" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field :model-value="alterarValorForm.valorAgua" label="Valor Água" readonly variant="solo-filled"
                class="readonly-highlight" hint="Valor da água (Read-only)" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field :model-value="alterarValorForm.taxaServicoAgua"
                @update:model-value="(v) => onCurrencyInput('taxaServicoAgua', v)" label="Taxa Serviço Água"
                hint="Taxa de serviço da água" />
            </v-col>

            <!-- Vencimento -->
            <v-col cols="12" class="mt-3">
              <h3 class="text-subtitle-1 mb-2">Total e Vencimento</h3>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field :model-value="alterarValorForm.valorBoleto"
                @update:model-value="(v) => onCurrencyInput('valorBoleto', v)" label="Valor Total Boleto (ex: 1.234,56)"
                hint="Valor total do boleto" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="alterarValorForm.dtvencimento" label="Vencimento" type="date"
                hint="Data de vencimento do boleto" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogs.alterarValor = false">Fechar</v-btn>
          <v-btn color="primary" @click="submitAlterarValor">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- v-dialogo com detalhes de um item selecionado -->
    <v-dialog v-if="!!itemDetails" v-model="itemDetails" max-width="600">
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <span>
              Detalhes do Boleto - {{ itemDetails.idrev }}
            </span>

            <v-icon class="ms-auto" @click="itemDetails = null" style="cursor: pointer;">mdi-close</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <v-list dense>
            <v-list-item>

              <v-list-item-title><strong>Razão Social:</strong> {{ itemDetails.razaosocial }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>Nº Pedidos Gás:</strong> {{ itemDetails.npedidos }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>Nº Pedidos Água:</strong> {{ itemDetails.npedidos_agua }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>Quantidade Gás:</strong> {{ itemDetails.quantidade }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>Quantidade Água:</strong> {{ itemDetails.quantidade_agua
                }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>Valor Boleto:</strong> {{ formatCurrency(itemDetails.valorBoleto)
                }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>Status Boleto:</strong> {{ itemDetails.statusboleto }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>Telefone:</strong> {{ itemDetails.telefone1 }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>Celular Responsável:</strong> {{ itemDetails.celularresponsavel
                }}</v-list-item-title>

            </v-list-item>
            <v-list-item>

              <v-list-item-title><strong>CNPJ:</strong> {{ itemDetails.cnpj }}</v-list-item-title>

            </v-list-item>
            <v-list-item v-if="itemDetails.link">

              <v-list-item-title><strong>Link do Boleto:</strong>
                <a :href="itemDetails.link" target="_blank">{{ itemDetails.link }}</a>
              </v-list-item-title>

            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch } from 'vue'
import html2pdf from 'html2pdf.js'
import * as XLSX from "xlsx";

import { formatToDateBR } from '@/utils/date'

import { useApi } from '@/utils/axios'
import { FINANCEIRO_ROTAS } from '@/utils/apiRoutes';
import { useNotificationStore } from '@/stores/notification';


const notificationStore = useNotificationStore();

const meta = {
  // filtros/metadados simplificados conforme especificação
  filters: [
    { name: 'status', type: 'select', options: [{ v: 'x', t: 'Todos' }, { v: '1', t: 'Sim (Pago)' }, { v: '0', t: 'Não (Não pago)' }] },
    { name: 'nf', type: 'select', options: [{ v: '', t: 'Todos' }, { v: 'S', t: 'Sim' }, { v: 'N', t: 'Não' }] },
    { name: 'dtinicio', type: 'date' },
    { name: 'dtfim', type: 'date' }
  ],
  limites: [10, 25, 50, 100, 150, 250, 500],
  columns: [
    { key: 'idrevendedor', title: 'ID Rev' },
    { key: 'razaosocial', title: 'Razão Social' },
    { key: 'npedidos', title: 'Nº Pedidos Gás' },
    { key: 'npedidos_agua', title: 'Nº Pedidos Água' },
    { key: 'quantidade', title: 'Quantidade Gás' },
    { key: 'quantidade_agua', title: 'Quantidade Água' },
    { key: 'valorBoleto', title: 'Valor Boleto' },
    { key: 'statusboleto', title: 'Pago?' },
    { key: 'data', title: 'Dt Boleto' },
    { key: 'vencimento', title: 'Validade' },
    { key: 'nf', title: 'NF' },
    { key: 'acoes', title: 'Ações' }
  ],
  statusboletoOptions: [{ v: 'S', t: 'Pago' }, { v: 'N', t: 'Não Pago' }, { v: 'PERDIDO', t: 'Perdido' }, { v: 'OUTRO', t: 'Outro' }],
  nfOptions: [{ v: 's', t: 'Sim' }, { v: 'n', t: 'Não' }],
  rowActions: [
    { v: 'detalhes', t: 'Ver Detalhes' },
    // { v: 0, t: 'Contactar' },
    // { v: 1, t: 'Negativado' },
    // { v: 2, t: 'Desativado' },
    // { v: 3, t: 'Boleto Itaú Feito' },
    // { v: 4, t: 'Sem contato' },
    { v: 5, t: 'Isentar mês' },
    { v: 6, t: 'Alterar Valor' },
    // { v: 7, t: 'Link' },
    { v: 'S', t: 'Marcar Pago' },
    { v: 'N', t: 'Marcar Não Pago' },
    { v: 'sperdido', t: 'Marcar Perdido' },
    { v: 'nperdido', t: 'Marcar Não Perdido' }
  ]
}

const filters = reactive({
  status: 'x',
  nf: '',
  dtinicio: '',
  dtfim: '',
  textoBusca: '',
  limite: 25
})

const itemDetails = ref(null)

const items = ref([])

const loading = ref(false)
const error = ref(null)

const filtersExpanded = ref(0);

// paginação / controle
const pagina = ref(1)
const itemsPerPage = ref(filters.limite)
watch(() => filters.limite, (v) => { itemsPerPage.value = v; pagina.value = 1 })

const totalItems = ref(0)
const totalPages = computed(() => Math.max(1, Math.ceil(totalItems.value / itemsPerPage.value)))

const tableHeaders = meta.columns.map(c => ({ title: c.title, key: c.key }))

// filtros simples locais (para skeleton). Datas em DD/MM/YYYY
function parseDateDMY(str) {
  if (!str) return null
  const parts = String(str).split('/')
  if (parts.length !== 3) return null
  const [d, m, y] = parts.map(p => parseInt(p, 10))
  if (!d || !m || !y) return null
  return new Date(y, m - 1, d)
}

function isValidDateDMY(str = '')/* 2017-04-19 */ {
  try {
    const dateSplit = str.split('/')

    const newDateStr = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`

    const date = new Date(newDateStr)
    date.setHours(date.getHours() + 3) // Ajuste de fuso horário

    // verificar se a data é valida
    if (date.toString() === 'Invalid Date') {
      return null
    }

    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  } catch (error) {
    return null
  }
}

async function search() {
  try {
    loading.value = true
    const response = await useApi(FINANCEIRO_ROTAS.GET_BOLETOS_PS).fetch({
      params: {
        page: pagina.value,
        per_page: filters.limite,
        statusboleto: filters.status !== 'x' ? filters.status : null,
        nf: filters.nf || null,
        dtinicio: filters.dtinicio || null,
        dtfim: filters.dtfim || null,
        pesquisar: filters.textoBusca || null
      }
    })
    items.value = response.data?.data || []
    totalItems.value = response.data?.total || items.value.length
  } catch (error) {
    error.value = error?.response?.data?.message || error.message || 'Erro ao buscar boletos';
    notificationStore.showNotification(error?.response?.data?.message || 'Erro ao buscar boletos', 'error');
  } finally {
    loading.value = false
  }
}

watch([pagina, itemsPerPage], () => {
  filters.limite = itemsPerPage.value
  search()
})

// totais
const totalValorBoleto = computed(() =>
  items.value.reduce((acc, it) => acc + (Number(it.valorBoleto) || 0), 0)
)

// helpers / stubs
function formatCurrency(v) {
  if (v == null) return '-'
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v)
}

/* Ações / exports - stubs */
function doCopy() {
  /* copiar para clipboard - stub */
  const element = document.getElementById('manual-root');
  const wb = XLSX.utils.table_to_book(element, { sheet: "Boletos" });
  const tsv = XLSX.utils.sheet_to_txt(wb.Sheets["Boletos"], { FS: '\t' });
  navigator.clipboard.writeText(tsv).then(() => {
    notificationStore.showNotification('Tabela copiada para a área de transferência.', 'success');
  }).catch(err => {
    notificationStore.showNotification('Erro ao copiar para a área de transferência: ' + err, 'error');
  });
}
function doCSV() {
  /* exportar CSV - stub */
  const element = document.getElementById('manual-root');
  const wb = XLSX.utils.table_to_book(element, { sheet: "Boletos" });
  const csv = XLSX.utils.sheet_to_csv(wb.Sheets["Boletos"]);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", "boletos.csv");
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
function doExcel() {
  /* exportar Excel - stub */
  const element = document.getElementById('manual-root');
  const wb = XLSX.utils.table_to_book(element, { sheet: "Boletos" });
  XLSX.writeFile(wb, "boletos.xlsx");
}
function doPDF() {
  /* exportar PDF - stub */
  const element = document.getElementById('manual-root');

  if (!element) return;

  const opt = {
    margin: 10, // mm
    filename: 'boletos.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, allowTaint: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
  };

  html2pdf().set(opt).from(element).save('boletos.pdf');
}
function doPrint() {
  /* imprimir - stub */
  const printWindow = window.open("", "_blank", "width=800,height=600");
  if (!printWindow) {
    return;
  }

  const manualRoot = document.getElementById("manual-root");
  if (!manualRoot) {
    printWindow.close();
    return;
  }

  printWindow.document.write(`
    <html>
      <head>
        <title>Gerenciar Boletos</title>
        <link rel="stylesheet" href="/src/assets/main.css" />
      </head>
      <body>${manualRoot.outerHTML}</body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
}

/* atualização por linha - stubs que no futuro farão requisições ao backend */
function updateRow(id, field, value) {
  // localizar item e atualizar localmente
  const i = items.value.find(x => x.id === id)
  if (i) i[field] = value
  // TODO: enviar request ao backend para persistir alteração
}

/* ações por linha (inclui abrir modal Alterar Valor) */
const dialogs = ref({ alterarValor: false })
const alterarValorForm = reactive({
  idboleto: null,
  npedidos: null,
  qtdGas: null,
  valorGas: null,
  taxaServicoGas: null,
  npedidosAgua: null,
  qtdAgua: null,
  valorAgua: null,
  taxaServicoAgua: null,
  valorBoleto: null,
  dtvencimento: null
})

async function handleRowAction(item, actionValue) {

  // valores numéricos e string tratados
  if (actionValue === 6) {
    // Alterar Valor - buscar detalhes do boleto da API
    try {
      loading.value = true
      const response = await useApi(FINANCEIRO_ROTAS.VALORES_BOLETO_PS(item.id)).fetch()

      if (response && response.data) {
        const detalhes = response.data
        alterarValorForm.idboleto = detalhes.id
        alterarValorForm.npedidos = detalhes.npedidos
        alterarValorForm.qtdGas = detalhes.quantidade
        alterarValorForm.valorGas = detalhes.valor_gas ? Number(detalhes.valor_gas).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : null
        alterarValorForm.taxaServicoGas = detalhes.taxa_servico_gas ? Number(detalhes.taxa_servico_gas).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : null
        alterarValorForm.npedidosAgua = detalhes.npedidos_agua
        alterarValorForm.qtdAgua = detalhes.quantidade_agua
        alterarValorForm.valorAgua = detalhes.valor_agua ? Number(detalhes.valor_agua).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : null
        alterarValorForm.taxaServicoAgua = detalhes.taxa_servico_agua ? Number(detalhes.taxa_servico_agua).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : null
        alterarValorForm.valorBoleto = detalhes.valorBoleto ? Number(detalhes.valorBoleto).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : null
        alterarValorForm.dtvencimento = detalhes.vencimento

        // Remove calculation of commisions as they are no longer used for tax calculation in the frontend

        dialogs.value.alterarValor = true
      } else {
        notificationStore.showNotification('Erro ao obter detalhes do boleto', 'error')
      }
    } catch (error) {
      console.error('Erro ao buscar detalhes do boleto:', error)
      notificationStore.showNotification(
        error?.response?.data?.message || 'Erro ao obter detalhes do boleto',
        'error'
      )
    } finally {
      loading.value = false
    }
    return
  }
  if (actionValue === 7) {
    // Link: abrir link do boleto (stub)
    if (item.link) {
      window.open(item.link, '_blank')
      return
    }
  }
  // Marca pagamento S/N etc.
  if (actionValue === 'S' || actionValue === 'N') {
    updateRow(item.id, 'statusboleto', actionValue)
    return
  }
  if (actionValue === 'sperdido') {
    updateRow(item.id, 'statusboleto', 'PERDIDO')
    return
  }
  if (actionValue === 'nperdido') {
    updateRow(item.id, 'statusboleto', 'N')
    return
  }
  if (actionValue === 'detalhes') {
    // Ver detalhes (stub)
    itemDetails.value = item
    return
  }
  // outros actions = stub
}

function onCurrencyInput(field, value) {
  if (value === null || value === undefined) {
    alterarValorForm[field] = null
    return
  }

  // Remove tudo que não for dígito
  let clean = String(value).replace(/\D/g, '')

  if (!clean) {
    alterarValorForm[field] = ''
    return
  }

  // Trata como centavos (estilo caixa eletrônico/calculadora)
  const numberValue = Number(clean) / 100

  // Formata para BRL
  alterarValorForm[field] = numberValue.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

/* Submeter alterar valor */
async function submitAlterarValor() {


  if (!alterarValorForm.idboleto) {
    console.error('ID do boleto não encontrado')
    return
  }

  try {
    // Preparar payload para enviar à API
    const payload = {}

    // Adicionar numero de pedidos de gás se foi alterado
    if (alterarValorForm.npedidos !== null && alterarValorForm.npedidos !== '') {
      payload.npedidos = Number(alterarValorForm.npedidos)
    }

    // Adicionar quantidade de gás se foi alterada
    if (alterarValorForm.qtdGas !== null && alterarValorForm.qtdGas !== '') {
      payload.quantidade = Number(alterarValorForm.qtdGas)
    }

    // Adicionar numero de pedidos de água se foi alterado
    if (alterarValorForm.npedidosAgua !== null && alterarValorForm.npedidosAgua !== '') {
      payload.npedidos_agua = Number(alterarValorForm.npedidosAgua)
    }

    // Adicionar quantidade de água se foi alterada
    if (alterarValorForm.qtdAgua !== null && alterarValorForm.qtdAgua !== '') {
      payload.quantidade_agua = Number(alterarValorForm.qtdAgua)
    }

    // Taxa de serviço do gás
    if (alterarValorForm.taxaServicoGas) {
      const parsedTaxaGas = Number(String(alterarValorForm.taxaServicoGas).replace(/\./g, '').replace(',', '.'))
      if (!isNaN(parsedTaxaGas)) {
        payload.taxa_servico_gas = parsedTaxaGas
      }
    }

    // Taxa de serviço da água
    if (alterarValorForm.taxaServicoAgua) {
      const parsedTaxaAgua = Number(String(alterarValorForm.taxaServicoAgua).replace(/\./g, '').replace(',', '.'))
      if (!isNaN(parsedTaxaAgua)) {
        payload.taxa_servico_agua = parsedTaxaAgua
      }
    }

    // Calcular e adicionar valor total do boleto - EDITÁVEL AGORA
    if (alterarValorForm.valorBoleto) {
      const parsedValor = Number(String(alterarValorForm.valorBoleto).replace(/\./g, '').replace(',', '.'))
      if (!isNaN(parsedValor)) payload.valorBoleto = parsedValor
    }

    // Adicionar vencimento se foi alterado
    if (alterarValorForm.dtvencimento) {
      payload.vencimento = alterarValorForm.dtvencimento
    }



    const response = await useApi(FINANCEIRO_ROTAS.ATUALIZAR_BOLETO_PS(alterarValorForm.idboleto)).put(payload)



    // Atualizar o item na tabela com os dados retornados pela API
    if (response.data?.data) {
      const i = items.value.find(x => x.id === alterarValorForm.idboleto)
      if (i) {
        if (response.data.data.npedidos !== undefined) i.npedidos = response.data.data.npedidos
        if (response.data.data.quantidade !== undefined) i.quantidade = response.data.data.quantidade
        if (response.data.data.npedidos_agua !== undefined) i.npedidos_agua = response.data.data.npedidos_agua
        if (response.data.data.quantidade_agua !== undefined) i.quantidade_agua = response.data.data.quantidade_agua
        if (response.data.data.valorBoleto !== undefined) i.valorBoleto = response.data.data.valorBoleto
        if (response.data.data.vencimento !== undefined) i.vencimento = response.data.data.vencimento


      }
    }

    notificationStore.showNotification('Valores atualizados com sucesso!', 'success')
    dialogs.value.alterarValor = false

  } catch (error) {
    console.error('Erro ao atualizar boleto:', error)
    notificationStore.showNotification(
      error?.response?.data?.message || 'Erro ao atualizar valores do boleto',
      'error'
    )
  }
}

/* novo estado para controlar seleção por linha (necessário para que v-select emita corretamente) */
const rowActionSelections = reactive({})

function onRowActionChange(item, actionValue) {
  if (actionValue == null || actionValue === '') return
  // encaminha para a função já existente
  handleRowAction(item, actionValue)
  // limpa a seleção para que a mesma ação possa ser escolhida novamente
  // usar nextTick se necessário; aqui setImmediate via setTimeout 0 é suficiente
  setTimeout(() => {
    delete rowActionSelections[item.id]
  }, 0)
}

/* Expor metadados e estados para template / debugging */
</script>

<style scoped>
/* ...existing styles... */

.readonly-highlight :deep(.v-field__input) {
  color: #000000 !important;
  /* Black color as requested */
  opacity: 1 !important;
  /* Ensure opacity is full */
}

/* Light background to differentiate from editable fields */
.readonly-highlight :deep(.v-field) {
  background-color: #E3F2FD !important;
  border-color: #BBDEFB !important;
}
</style>
